import React from 'react'
import {Select, message} from 'antd'
const Option = Select.Option
import Tools from '../tools/Tools'
export default class InstructStatusSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            instructStatusList:[],
            value:props.value||null
        }
        this.getInstructTypeList = this.getInstructTypeList.bind(this)
    }

    componentDidMount() {
        if(!Tools.isHasWholeEnum(this.props.platform)){
            this.getInstructTypeList()
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.value != this.state.value ) {
            this.setState({
                value:nextProps.value
            })
        }
    }

    getInstructTypeList() {
        let url = Tools.getApiUrl("taskStatusEnum",this.props.platform)
        let that = this
        Tools.fetch(url,'GET',function (data) {
            if (data.code == 0) {
                that.setState({
                    instructStatusList:data.data
                })
            } else {
                message.error(data.message)
            }
        })
    }

    render() {
        const {instructStatusList, value} = this.state
        const {onChange,showAll,platform} = this.props
        let instructStatusOptions = Tools.isHasWholeEnum(platform)?Tools.getOptionsFromGlobalEnums("instructStatus"):instructStatusList.map(function (item) {
            return <Option key={item.key} value={item.key}>{item.value}</Option>
        })
        return  <Select value={value}    style={{width: 230, marginRight: 10}}
                        placeholder={Strings.rs14382}
                        onChange={(value)=>{
                            this.setState({
                                value
                            })
                            onChange(value)
                        }}>
            {showAll?<Option key={''} value={''}>{Strings.rs10613 || Strings.all}</Option>:null}
            {instructStatusOptions}
        </Select>
    }

}